/**
 * DE QUEL ENVIRONNEMENT PARLE CET ÉVÉNEMENT (DEV-1508 lot 3).
 * ============================================================================
 *
 * INTENTION : pouvoir répondre « est-ce que ça marche sur staging ? » sans
 * deviner. Jusqu'ici, une ligne de `frontend-events` ne disait pas d'où elle
 * venait : staging et production versaient dans la même source, avec la même
 * forme, et chercher un événement manquant revenait à chercher dans le noir.
 *
 * Le bundle est le MÊME partout (les secrets Better Stack sont partagés entre
 * environnements), donc rien ne peut être décidé à la compilation : c'est
 * l'adresse servie au navigateur qui tranche, et elle se lit au runtime.
 *
 * ⚠️ Aucune valeur par défaut flatteuse : une adresse inconnue vaut « inconnu »,
 * jamais « prod ». Un environnement deviné est pire qu'un environnement absent.
 */

export type TrackingEnv = "dev" | "staging" | "preprod" | "prod" | "inconnu"

/** L'adresse de la production. Tout le reste se prouve. */
const HOTE_PROD = "app.homeys.io"

/**
 * Déduit l'environnement de l'adresse servie.
 *
 * @param hostname - `window.location.hostname`
 * @param modeDev - vrai quand le bundle tourne en mode développement (Vite)
 */
export function deduireEnv(
    hostname: string | null | undefined,
    modeDev = false
): TrackingEnv {
    const hote = (hostname ?? "").trim().toLowerCase()
    if (
        modeDev ||
        hote === "localhost" ||
        hote === "127.0.0.1" ||
        hote === "[::1]" ||
        hote.endsWith(".localhost")
    ) {
        return "dev"
    }
    if (hote === "") return "inconnu"
    if (hote === HOTE_PROD) return "prod"
    // L'ordre compte : `factures-preprod` contient bien « preprod », et une
    // adresse de préproduction n'est pas une adresse de recette.
    if (hote.includes("preprod")) return "preprod"
    if (hote.includes("staging")) return "staging"
    return "inconnu"
}
